import Axios from 'axios'

const token = localStorage.getItem('@token')
const baseUrl = process.env.REACT_APP_BASE_URL

const API = Axios.create({
    baseURL: baseUrl,
    timeout: 30000,
    headers: {
        "Accept": 'application/json',
        "Content-Type": 'application/json',
        "Authorization": `Bearer ${token}`
    }
})

// Remove Content-Type para FormData: o browser define o boundary correto automaticamente
API.interceptors.request.use(config => {
    if (config.data instanceof FormData) {
        delete config.headers['Content-Type']
    }
    return config
})

API.interceptors.response.use(res => {
    return res
}, err => {

    // Disconnect on unauthenticated
    if(err?.response?.status === 401){
        localStorage.clear()
        window.location.href="/"
        setTimeout(() => {
            window.location.reload()
        }, 1000)
    }

    throw err

})

export default API